import { ItemContent, StyledItemContent, StyledTopContent, StyledTypography } from "./StyledComponents";
import { ReactElement } from "react";
import { Typography } from "@kaltura/ds-react-components";
import { Check16Icon } from "@kaltura/ds-react-icons";

type PrivacyMenuItemContentProps = {
    icon: ReactElement;
    title: string;
    description: string;
    isSelected: boolean;
};

const PrivacyMenuItemContent = (props: PrivacyMenuItemContentProps) => {
    const { icon, title, description, isSelected } = props;

    return (
        <ItemContent>
            <div>{icon}</div>
            <StyledItemContent>
                <StyledTopContent>
                    <Typography variant={"body2Highlight"}>{title}</Typography>
                    <div>{isSelected && <Check16Icon />}</div>
                </StyledTopContent>
                <StyledTypography variant={"body2"}>{description}</StyledTypography>
            </StyledItemContent>
        </ItemContent>
    );
};

export default PrivacyMenuItemContent;
